import { createContext, useContext, useRef, useState } from "react";
import ModalConfirm from "../../components/modal-confirm";

export interface IConfirmModalProps {
  // eslint-disable-next-line no-unused-vars
  showConfirmationDialog: (message: string) => Promise<boolean>;
}

const ConfirmModalContext = createContext({} as IConfirmModalProps);

export const useConfirmModal = () => useContext(ConfirmModalContext);

export function ConfirmModalProvider({ children }: { children: any }) {
  const [open, setOpen] = useState<boolean>(false);
  const [message, setMessage] = useState<string>();
  const resolver = useRef<Function>();

  const handleOpen = (message: string): Promise<boolean> => {
    setMessage(message);
    setOpen(true);
    return new Promise(function (resolve) {
      resolver.current = resolve;
    });
  };

  const handleOk = () => {
    resolver.current && resolver.current(true);
    setOpen(false);
  };

  const handleCancel = () => {
    resolver.current && resolver.current(false);
    setOpen(false);
  };

  return (
    <ConfirmModalContext.Provider
      value={{
        showConfirmationDialog: handleOpen,
      }}
    >
      <ModalConfirm message={message} open={open} onConfirm={handleOk} onClose={handleCancel} />
      {children}
    </ConfirmModalContext.Provider>
  );
}
